function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("style", null, ".download_svg__st0{fill:#e47b3b}");

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "download_svg__st0",
  d: "M36 46.2l18.9-20.5H17.1z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "download_svg__st0",
  d: "M28.8 12.6h14.4v20.9H28.8zM17.1 53h37.8v6.4H17.1z"
});

var SvgDownload = function SvgDownload(props) {
  return React.createElement("svg", _extends({
    id: "download_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 72 72",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA3MiA3MiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNzIgNzI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRTQ3QjNCO30KPC9zdHlsZT4KPGc+Cgk8cG9seWdvbiBjbGFzcz0ic3QwIiBwb2ludHM9IjM2LDQ2LjIgNTQuOSwyNS43IDE3LjEsMjUuNyAJIi8+Cgk8cmVjdCB4PSIyOC44IiB5PSIxMi42IiBjbGFzcz0ic3QwIiB3aWR0aD0iMTQuNCIgaGVpZ2h0PSIyMC45Ii8+Cgk8cmVjdCB4PSIxNy4xIiB5PSI1MyIgY2xhc3M9InN0MCIgd2lkdGg9IjM3LjgiIGhlaWdodD0iNi40Ii8+CjwvZz4KPC9zdmc+Cg==";
export { SvgDownload as ReactComponent };